/**
 * Persistencia de filtros de los listados (documentos, usuarios, clientes) en
 * sessionStorage: sobrevive a navegar al detalle y volver (la página se
 * desmonta/remonta), pero no contamina entre sesiones (se limpia al cerrar
 * la pestaña). Cada payload incluye `serviceId` para descartar filtros de
 * otro servicio al restaurar.
 */
const PREFIX = 'sentry_filters_';

export const saveFilters = (key, value) => {
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch (_e) {
    // QuotaExceeded o storage deshabilitado — la persistencia es best-effort
  }
};

export const loadFilters = (key) => {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
};

/** Mezcla campos sobre lo ya guardado (para no pisar lo que guarda otro componente). */
export const mergeFilters = (key, partial) => {
  const prev = loadFilters(key) || {};
  saveFilters(key, { ...prev, ...partial });
};

export const clearFilters = (key) => {
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch (_e) {
    // ignorar
  }
};
